<div *ngIf="isLoading" class="overlay">
  <mat-spinner class="loading-spinner" diameter="50"></mat-spinner>
</div>


<mat-dialog-content>
  <form #matchForm="ngForm">
    <mat-form-field appearance="outline">
      <mat-label>Numri i javës</mat-label>
      <input [(ngModel)]="weekNumber" [min]="0" disabled="true" matInput name="weekNumber" readonly="true" required
             type="number">
    </mat-form-field>

    <div *ngFor="let match of matches; let i = index">
      <div style="display: flex; justify-content: space-between">
        <h4>Match {{ i + 1 }}</h4>

        <button (click)="removeMatch(i)" color="warn" mat-icon-button>
          <mat-icon>remove_circle</mat-icon>
        </button>
      </div>

      <div style="display: flex; gap: 1rem;">
        <mat-form-field appearance="outline" style="flex: 1;">
          <mat-label>{{'Game Date' | translate}}</mat-label>
          <input [(ngModel)]="match.gameDate" [matDatepicker]="picker" matInput name="gameDate{{i}}" />
          <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" style="flex: 1;">
          <mat-label>Koha e ndeshjes</mat-label>
          <input [(ngModel)]="match.gameTime" matInput name="gameTime{{i}}" type="time"/>
        </mat-form-field>
      </div>

      <div style="display: flex; gap: 1rem;">
        <mat-form-field appearance="outline" style="flex: 1;">
          <mat-label>Ekipi vendase</mat-label>
          <mat-select (selectionChange)="filterAwayTeams(i)" [(ngModel)]="match.homeTeamId" name="homeTeamId{{i}}"
                      required>
            <mat-option *ngFor="let team of filteredHomeTeams[i]" [value]="team.id">{{ team.name }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="flex: 1;">
          <mat-label>Ekipi mysafire</mat-label>
          <mat-select [(ngModel)]="match.awayTeamId" name="awayTeamId{{i}}" required>
            <mat-option *ngFor="let team of filteredAwayTeams[i]" [value]="team.id">{{ team.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="display: flex; gap: 1rem;">
        <mat-form-field appearance="outline" style="flex: 1;">
          <mat-label>Rezultati i ekipit vendas</mat-label>
          <input [(ngModel)]="match.homeTeamScore" [min]="0" [disabled]="match.status === 'UPCOMING'" matInput
                 name="homeTeamScore{{i}}" type="number">
        </mat-form-field>

        <mat-form-field appearance="outline" style="flex: 1;">
          <mat-label>Rezultati i ekipit mysafire</mat-label>
          <input [(ngModel)]="match.awayTeamScore" [min]="0" [disabled]="match.status === 'UPCOMING'" matInput
                 name="awayTeamScore{{i}}" type="number">
        </mat-form-field>
      </div>

      <div style="display: flex; gap: 1rem;">
        <mat-form-field appearance="outline" style="width: 365px">
          <mat-label>{{'Status' | translate}}</mat-label>
          <mat-select [(ngModel)]="match.status" name="status{{i}}">
            <mat-option *ngFor="let status of matchStatuses" [value]="status">
              {{ status }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <div style="display: flex; justify-content: space-between; width: 100%;">
    <div>
      <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
      <button (click)="addMatch()" [disabled]="!isSaveDisabled" color="primary" mat-raised-button type="button">
        Shto një ndeshje tjetër
      </button>
    </div>
    <div>
      <button (click)="save()" [disabled]="isSaveDisabled" color="primary" mat-raised-button>Krijo</button>
    </div>
  </div>
</mat-dialog-actions>

